export const columnsContracts = [
    {
        name: '#',
        maxWidth: '40px',
        minWidth: '20px',
        selector: (row, index) => index,
        cell: (row, index) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="text-truncate text-body">
                        <span className="fw-bolder">{index + 1}</span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Version',
        maxWidth: '120px',
        minWidth: '80px',
        selector: (row) => row.version,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center text-truncate">
                <div className="d-flex flex-column">
                    <p className="text-truncate text-body">
                        <span className="fw-bolder">
                            {row.version || 'None'}
                        </span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Type',
        maxWidth: '100px',
        minWidth: '80px',
        selector: (row) => row.type,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="text-truncate text-body">
                        <span className="fw-bolder">{row.type || 'None'}</span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Name',
        maxWidth: 'none',
        minWidth: '160px',
        selector: (row) => row?.customName ?? row.name,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center text-truncate">
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{row?.customName ?? row.name}</span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: 'Address',
        maxWidth: 'none',
        minWidth: '160px',
        selector: (row) => row.address,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{`${row.address.slice(
                        0,
                        5
                    )}...${row.address.slice(-6)}`}</span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: 'Description',
        flexBasis: '20%',
        selector: (row) => row?.customDescription ?? row.description,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <p className="text-truncate text-body word-wrap">
                    <span
                        className="fw-bolder"
                        style={{ whiteSpace: 'break-spaces' }}
                    >
                        {row?.customDescription ?? row.description}
                    </span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: 'GAS',
        flexBasis: '10%',
        selector: (row) => row.gas,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{row.gas}</span>
                    <br />
                </p>
            </div>
        ),
    },
];
